import { useState } from 'react';
import type { FormEvent } from 'react';
import { Logo } from '../../components/layout/Logo';
import { Field } from '../../components/ui/Field';
import { useLogin } from '../../lib/queries';
import { ApiError } from '../../lib/api';
import './login.css';

export function LoginScreen() {
  const login = useLogin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate({ username: username.trim(), password });
  };

  const error = login.error instanceof ApiError ? login.error.message : null;

  return (
    <div className="login">
      <div className="login-panel">
        <div className="login-brand">
          <Logo height={26} />
        </div>

        <div className="login-intro">
          <h1>Schichtplanung</h1>
          <p className="muted">
            Baustellen-Einteilung, Verfügbarkeiten und Mitarbeiterdaten an einer Stelle.
          </p>
        </div>

        <form className="stack" onSubmit={submit} noValidate>
          <Field label="Benutzername">
            {(props) => (
              <input
                {...props}
                className="input"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={(event) => setUsername(event.target.value)}
              />
            )}
          </Field>

          <Field label="Passwort">
            {(props) => (
              <input
                {...props}
                className="input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            )}
          </Field>

          {error ? (
            <p className="form-error" role="alert">
              {error}
            </p>
          ) : null}

          <button
            type="submit"
            className="btn btn-signal"
            disabled={login.isPending || !username || !password}
          >
            {login.isPending ? 'Wird angemeldet …' : 'Anmelden'}
          </button>
        </form>

        <p className="login-note">
          Beim ersten Start legt der Server ein Administratorkonto an. Benutzername und Passwort
          stehen in der Datei <code>ERSTE-ANMELDUNG.txt</code> im Datenordner.
        </p>
      </div>
    </div>
  );
}
